module.exports = __webpack_public_path__ + "media/images/payment/mastercard-182911c044c145959ec7074af41e5718.svg";